<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="260"
  >
    <v-img
      :src="image"
      height="100%"
    >
      <v-layout
        class="fill-height"
        tag="v-list"
        column
      >
        <v-list-tile avatar>
          <v-list-tile-title class="title">
            <v-img
              :src="logo"
              height="80"
              contain
            />
          </v-list-tile-title>
        </v-list-tile>
        <v-divider/>
        <v-list-tile
          v-for="(link, i) in links"
          :key="i"
          :to="link.to"
          :active-class="color"
          avatar
          class="v-list-item"
        >
          <v-list-tile-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="link.text"
          />
        </v-list-tile>
        <v-list-tile
          active-class="primary"
          class="v-list-item v-list__tile--buy"
          @click="signOutOidc"
        >
          <v-list-tile-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="font-weight-light">
            Logout
          </v-list-tile-title>
        </v-list-tile>
      </v-layout>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
import { Sentry } from '@/apis/sentry'

export default {
  data: () => ({
    logo: '/img/logo.png',
    responsive: false
  }),

  computed: {
    ...mapState('app', ['image', 'color']),
    ...mapGetters(['oidcIsAuthenticated']),
    
    inputValue: {
      get () {
        return this.$store.state.app.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    },
    
    items () {
      return this.$t('Layout.View.items')
    }
  },

  asyncComputed: {
    async links() {
      var val = [];
      if (this.oidcIsAuthenticated) {
        val.push({
          to: '/dashboard',
          icon: 'mdi-view-dashboard',
          text: 'Dashboard'
        });

        if (await Sentry.hasPermission('SoftPro.Atmos', 'SoftPro.Atmos/Subscription/Read')) {        
          val.push({
              to: '/subs',
              icon: 'mdi-currency-usd',
              text: 'Subscriptions'
            })
        }
        
        val.push({
          to: '/apps',
          icon: 'mdi-widgets',
          text: 'Applications'
        })

        if (await Sentry.hasPermission('SoftPro.Atmos', 'SoftPro.Authorization/Permission/Read')) {
          val.push({
              to: '/system',
              icon: 'mdi-settings-outline',
              text: 'System'
            })
        }
      }      
      return val;
    },
  },
  
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    ...mapActions(['signOutOidc']),
    
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    }
  }
}
</script>

<style lang="scss">
  #app-drawer {
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

    .v-image__image--contain {
      top: 9px;
      height: 80%;
    }

    .search-input {
      margin-bottom: 30px !important;
      padding-left: 15px;
      padding-right: 15px;
    }
  }
</style>
